// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"3fbb0c53","99":"07ed3817","103":"c64f2780","161":"a1048a0a","181":"0bc8c0f8","240":"c4cac1e4","349":"d89cf7d8","411":"3febe6d9","606":"63e4187c","717":"c900a99b","813":"2ed27c95","896":"a37c8811","963":"1ef9c09d"}[chunkId] + ".chunk.js";
};